import FooterNavigationSection from "./FooterNavigationSection";

export default FooterNavigationSection;
